export class FileUploadRequest {
    file: File;
    company_id?: string;
    requestId?: string;
    type?: string;
    department?: string;
    typeUser?: string;
    competence?: string;
}